import 'css-chunksrc/client/scenes/notifications/notification/styles.scss';export default {
  "notification": "_notification_1emps_1",
  "main": "_main_1emps_5",
  "readIndication": "_readIndication_1emps_9",
  "readMark": "_readMark_1emps_13",
  "read": "_read_1emps_9"
};